import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { updateLike, updateBookmark } from "./likeSavedApi";

const initialState = {
    updatedBlog: {},
    isLoading: false,
    isError: false,
    error: "",
};

// async thunk
export const updateBlogLike = createAsyncThunk(
    "likeSaved/updateBlogLike",
    async ({ id, blogLikes }) => {
        const blog = await updateLike(id, blogLikes);
        return blog;
    }
);

export const updateBookmarkBlog = createAsyncThunk(
    "likeSaved/updateBookmark",
    async ({ id, isSaved }) => {
        const blog = await updateBookmark(id, isSaved);
        return blog;
    }
);

const likeSavedSlice = createSlice({
    name: "likeSaved",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(updateBlogLike.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(updateBlogLike.fulfilled, (state, action) => {
                state.isLoading = false;
                state.updatedBlog = action.payload;
            })
            .addCase(updateBlogLike.rejected, (state, action) => {
                state.isLoading = false;
                state.updatedBlog = {};
                state.isError = true;
                state.error = action.error?.message;
            })
            .addCase(updateBookmarkBlog.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(updateBookmarkBlog.fulfilled, (state, action) => {
                state.isLoading = false;
                state.updatedBlog = action.payload;
            })
            .addCase(updateBookmarkBlog.rejected, (state, action) => {
                state.isLoading = false;
                state.updatedBlog = {};
                state.isError = true;
                state.error = action.error?.message;
            });
    },
});

export default likeSavedSlice.reducer;
